import { render, staticRenderFns } from "./InsuranceProductEdit.vue?vue&type=template&id=6aa4b84e&scoped=true"
import script from "./InsuranceProductEdit.vue?vue&type=script&lang=js"
export * from "./InsuranceProductEdit.vue?vue&type=script&lang=js"
import style0 from "./InsuranceProductEdit.vue?vue&type=style&index=0&id=6aa4b84e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4b84e",
  null
  
)

export default component.exports